import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard, PendingChangesGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { VendorSearchComponent } from './vendor-search/vendor-search.component';
import { VendorDetailComponent } from './vendor-detail/vendor-detail.component';



@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'vendors',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: VendorSearchComponent, data: { title: 'Vendors' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'overview/:id', component: VendorDetailComponent, data: { title: 'Vendor Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        VendorSearchComponent, VendorDetailComponent
    ]
})
export class VendorsModule {}
